import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Category, CategoryEnum, Item, Product, Talle } from '../types/types';
import { environment } from '../../environments/environment';
import { AngularFireStorage, AngularFireStorageReference } from '@angular/fire/storage';



const carrouselImgs : string[] = [
  "https://bloximages.newyork1.vip.townnews.com/lancasteronline.com/content/tncms/assets/v3/editorial/4/bb/4bb88d2e-bfa4-11e9-bb2c-9711825d9519/5d55cfd0aed9a.image.jpg?resize=1200%2C800",
  "https://image.freepik.com/foto-gratis/grupo-ninos-kindergarten-amigos-brazo-alrededor-sentado-sonriendo-divertido_53876-2350.jpg",
  "https://statics.losan.com/sites/default/files/gadget_galeria_files/cabecera_1020x900_infantil.jpg",
  "https://statics.losan.com/sites/default/files/modulo_quieres_vender_losan_2.jpg"
  
]
const categoriesEnum : CategoryEnum[] = ['Baby','Kid','New Born','Accesorios'];

const categories : Category[] = [
  { name : 'New Born', description:"De 0 a 6 meses",imgUrl:"https://estaticos.serpadres.es/media/cache/480x360_thumb/uploads/images/dossier/5481a1c108d8641a135777bf/185424417.jpg"},
  { name : 'Baby', description:"De 6 meses a 3 años",imgUrl:"https://alvarobilbao.com/wp-content/uploads/2020/03/Ni%C3%B1o-3-a%C3%B1os-1200x900.jpg"},
  { name : 'Kid', description:"De 3 a 9 años",imgUrl:"https://lh3.googleusercontent.com/XCwCXybY1ECJCS1VGae5I78PEY6no22DXrGSgCx-6lTlPqZEvvYKzVOViOFBs2DJrB72pXKNvHZctnHyWAfiPUfO042DKwniJCJLW5On1FTbEPxkLhq9wcg74C57lEWdfiJgSPbC5gSmdESaUl-oOHAeP1NqBh1g1btAaoy5w7HiacZCi0ufKZh-SQRuiitVrBLZcPliJFkOxMrEaxhOspPSsMGzCPyAVZEA4PCfi65CwaL9HDcTN5M5IUXiQpzgAZxQb_lx8iYTss361IYQKzN82bivD3KcoOWQf7Ua474oy2pLRYrwwEN-2wIFJS5JWU9SV5O71PxIYdNmys8wXovd2gNCy4W4b8gizRq5g243kV0s3dVMI9znj3wBGAKSk6aXDhVOx5WS5FwLgFSDjWr5vPqu3qynbvbm8U5jeWWcTntDj_yooTStrIn7HKnvs6s1SMKkDiq0A2EA5muw4LWcirBQet9BjY7Qw6q7cB7m4KG9qe6ghVU54Hf8fFywqSJOE6tH05kwTIyu7fRuoQCjsOHKU3yGOXaBb_Jj5T370r3kSXb_igMZEmo11AyPgmPwwwnE9vj7DBoxxnQyphyJyoNgtBV8HsRUaIBhI-HlOPxIZaWROfcO_J3aziCJjq-SR8gSOc2WE5dcAdJmpjF9cV1EQm8osW77O9jPaqzydmmHmQX6d5B96KzkHnite9jhfpeUadqZCPLgp1U5Ay4P=w678-h912-no?authuser=0"},
  { name : "Accesorios", description:"Baberos, boxers, etc ...",imgUrl:"https://i.pinimg.com/originals/90/ea/07/90ea0727d88e928527b4f9d00f97444f.jpg"},
]

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  
  private productsUrl = `${environment.API_URL}/product`;  // URL to web api

  products : Product[] = [];
  
  constructor(private http: HttpClient, private storage : AngularFireStorage) {
   }

  getProductsFromCategory(categoryName:string) {
    return this.products.filter(p => p.category === categoryName)
  }

  getTalles() : Talle[]{
    return ['000' , '00', '0' , '1' , '2' , '3', '4' , '5' , '6', '8' , '10' , '12' , '14', 'Único']
  }

  getAllVisibleProducts() {
    return this.http.get<Product[]>(this.productsUrl+"/visible");
  }

  getAllProducts(){
    /** GET Products from the server */
  return this.http.get<Product[]>(this.productsUrl+"/");
  }

  getProduct(pid:number) {
    return this.http.get<Product>(this.productsUrl+`/${pid}`);
  }

  getCategories() {
    return categories;
  }

  getCarrouselImgs() {
    return carrouselImgs;
  }

  searchBy(value : string) {
    return this.products.filter(e => !e.name.includes(value))
  }

  getTrendingProducts() {
    return this.http.get<Product[]>(this.productsUrl+"/trending");
  }

  saveProduct(product:Product) {
    return this.http.post<Product>(this.productsUrl+"/",product);
  }

  delete(product : Product) {
    if(product.imgUrl.includes("firebasestorage")){
      const photoRef : any = this.storage.storage.refFromURL(product.imgUrl).delete()
      .then(() => console.log(" IMAGE DELETED "))
      .catch( err => console.log("IMAGE NOT DELETED"));
    }
    return this.http.delete(this.productsUrl+`/${product._id}`)
  }

  update(body:Product) {
    return this.http.put<Product>(this.productsUrl+"/",body);
  }
}
